import React from 'react';
import { useLocation } from 'react-router-dom';
import CorporateKitsDetails from 'components/business/corporate-kits/CorporateKitsDetails';
import CorporateKits from 'components/business/CorporateKits';

export const ConcentsCtx = React.createContext({});

function DoctorKitsPageProvider(props) {
  const ctx = {
  };
  return (
    <ConcentsCtx.Provider value={ ctx }>
      {props.children}
    </ConcentsCtx.Provider>
  );
}

function CorporateKitsPage() {
  const location = useLocation();
  const { search } = location;
  const params = new URLSearchParams(search);
  const id = params.get('id');

  if (null != id) {
    return <CorporateKitsDetails id={ id } />;
  }

  return (
    <DoctorKitsPageProvider>
      <CorporateKits />
    </DoctorKitsPageProvider>
  );
}

export default CorporateKitsPage;
